import { render, staticRenderFns } from "./WeekMrp.vue?vue&type=template&id=5215a1d6&"
import script from "./WeekMrp.vue?vue&type=script&lang=js&"
export * from "./WeekMrp.vue?vue&type=script&lang=js&"
import style0 from "./WeekMrp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
